import { Checkbox, type CheckboxChangeEvent } from 'primereact/checkbox';
import { classNames } from 'primereact/utils';
import type React from 'react';
import { useState } from 'react';
import style from '../views/program.module.css';

type Props = {
	icon: React.ReactNode;
	name: string;
	count: number;
	groups: Group[];
};

interface Group {
	name: string;
	description: string;
	peopleCount: number;
}

const PeopleItem = (props: Props) => {
	const { icon, name, count, groups } = props;

	const [selectedGroups, setSelectedGroups] = useState<Group[]>([]);

	const isChecked = selectedGroups.some((item) => item.name === name);

	const handleChange = (e: CheckboxChangeEvent) => {
		let _selectedGroups = [...selectedGroups];

		const selectedGroup = groups.find((group) => group.name === e.value);

		if (e.checked && selectedGroup) {
			_selectedGroups.push(selectedGroup);
		} else {
			_selectedGroups = _selectedGroups.filter(
				(group) => group.name !== e.value,
			);
		}

		setSelectedGroups(_selectedGroups);
	};

	return (
		<div className="flex w-full items-center justify-between py-3 px-4 border-b border-gray-200 cursor-pointer hover:bg-gray-50">
			<div className="flex gap-2 w-1/2">
				<div className="mr-4">{icon}</div>
				<span className="text-body-medium text-base text-left text-neutral17">
					{name}
				</span>
			</div>

			<div className="w-1/2 text-left">
				<p className="text-neutral60 text-base text-body-medium">
					{count}
				</p>
			</div>

			<div className="flex items-center">
				<Checkbox
					size={24}
					value={name}
					onChange={handleChange}
					checked={isChecked}
					pt={{
						root: {
							className: 'hover:bg-transparent',
						},
						box: {
							className: classNames(
								style['program-checkbox-input'],
								{
									[style['program-checkbox-input-checked']]:
										isChecked,
								},
							),
						},
						icon: {
							className: classNames(
								style['program-checkbox-icon'],
							),
						},
					}}
				/>
			</div>
		</div>
	);
};

export default PeopleItem;
